import UserImage from "@/components/utils/UserImage";
import { Organization } from "@/models/crunchbase/Organization";
import { Funder } from "@/types/FunderTypes";
import { Box, Typography } from "@mui/material";
import BaseFunderTemplate from "./BaseFunderTemplate";

interface Props {
  funder: Funder;
}

const CompanyTemplate = (props: Props) => {
  const company = props.funder.entity as Organization;

  const numberOfInvestments = props?.funder?.companyAdditionalFields?.investmentCount;
  const numberOfExits = null;

  return (
    <BaseFunderTemplate>
      <>
        <Box className="header">
          <UserImage src={company.logoUrl} company />
          <Typography>{company.name}</Typography>
        </Box>
        <Typography className="content">{company.shortDescription}</Typography>

        <Typography fontWeight={500}>
          {company.city} {company.stateCode} {company.countryCode}
        </Typography>
        {numberOfExits !== null ||
          (numberOfInvestments !== null && (
            <Box className="footer">
              {numberOfInvestments !== null && (
                <Box>
                  <Typography className="grey-text">Number of Investments</Typography>
                  <Typography>{numberOfInvestments}</Typography>
                </Box>
              )}
              {numberOfExits && (
                <Box>
                  <Typography className="grey-text">Number of Exits</Typography>
                  <Typography>{numberOfExits}</Typography>
                </Box>
              )}
            </Box>
          ))}
      </>
    </BaseFunderTemplate>
  );
};
export default CompanyTemplate;
